import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {LoginRequestPayload, LoginResponsePayload} from "../../interfaces";

interface AuthState {
    loginResponse: LoginResponsePayload | null
}

const initialState: AuthState = {
    loginResponse: null
}

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        loginRequest: (state, action: PayloadAction<LoginRequestPayload>) => {
            state.loginResponse = null
        },
        loginSuccess: (state, action: PayloadAction<LoginResponsePayload>) => {
            state.loginResponse = action.payload

        },
        loginError: (state, action: PayloadAction<any>) => {
            state.loginResponse = null
        },

        resetLoginState: (state) => {
            state.loginResponse = null; // Reset di tutti gli stati legati alla login
        },
    }
})

export const {
    loginRequest,
    loginSuccess,
    loginError,
    resetLoginState
} = authSlice.actions

export default authSlice.reducer